import { useState } from "react";
import Popup from "../../../../popup";
import EvaluationForm from "../evaluationForm";

const AddEvaluation = ({ currentSessionDate, isShowingNewEvaluationPopup, setIsShowingNewEvaluationPopup, recharge, setRecharge }) => {
  const [evaluationDate] = useState(currentSessionDate);
  const [evaluationTime, setEvaluationTime] = useState("");
  const [RASS, setRASS] = useState("");
  const [Dyspnoea, setDyspnoea] = useState("");
  const [Pain, setPain] = useState("");
  const [AnxiousSymptomatology, setAnxiousSymptomatology] = useState("");
  const [DepressiveSymptoms, setDepressiveSymptoms] = useState("");
  const [Delirium, setDelirium] = useState("-");
  const [MechanicalVentilation, setMechanicalVentilation] = useState("-");
  const [Position, setPosition] = useState("-");
  const [Sleep, setSleep] = useState("");
  const [Mobility, setMobility] = useState("-");
  const [Observations, setObservations] = useState("");
  // Handle errors
  const [evaluationTimeError, setEvaluationTimeError] = useState(false);
  const [RASSError, setRASSError] = useState(false);
  const [DyspnoeaError, setDyspnoeaError] = useState(false);
  const [PainError, setPainError] = useState(false);
  const [AnxiousSymptomatologyError, setAnxiousSymptomatologyError] = useState(false);
  const [DepressiveSymptomsError, setDepressiveSymptomsError] = useState(false);
  const [SleepError, setSleepError] = useState(false);

  return (
    <Popup isShowed={isShowingNewEvaluationPopup} setIsShowed={setIsShowingNewEvaluationPopup}>
      <EvaluationForm
        type="create"
        evaluationDate={evaluationDate}
        evaluationTime={evaluationTime}
        setEvaluationTime={setEvaluationTime}
        evaluationTimeError={evaluationTimeError}
        setEvaluationTimeError={setEvaluationTimeError}
        RASS={RASS}
        setRASS={setRASS}
        RASSError={RASSError}
        setRASSError={setRASSError}
        Dyspnoea={Dyspnoea}
        setDyspnoea={setDyspnoea}
        DyspnoeaError={DyspnoeaError}
        setDyspnoeaError={setDyspnoeaError}
        Pain={Pain}
        setPain={setPain}
        PainError={PainError}
        setPainError={setPainError}
        AnxiousSymptomatology={AnxiousSymptomatology}
        setAnxiousSymptomatology={setAnxiousSymptomatology}
        AnxiousSymptomatologyError={AnxiousSymptomatologyError}
        setAnxiousSymptomatologyError={setAnxiousSymptomatologyError}
        DepressiveSymptoms={DepressiveSymptoms}
        setDepressiveSymptoms={setDepressiveSymptoms}
        DepressiveSymptomsError={DepressiveSymptomsError}
        setDepressiveSymptomsError={setDepressiveSymptomsError}
        Delirium={Delirium}
        setDelirium={setDelirium}
        MechanicalVentilation={MechanicalVentilation}
        setMechanicalVentilation={setMechanicalVentilation}
        Position={Position}
        setPosition={setPosition}
        Sleep={Sleep}
        setSleep={setSleep}
        SleepError={SleepError}
        setSleepError={setSleepError}
        Mobility={Mobility}
        setMobility={setMobility}
        Observations={Observations}
        setObservations={setObservations}
        setIsShowingEvaluationPopup={setIsShowingNewEvaluationPopup}
        recharge={recharge}
        setRecharge={setRecharge}
      />
    </Popup>
  );
};

export default AddEvaluation;
